import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../../widgets/form/InputTextSF'

const RepaymentPrincipalModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted, status,
  // event handlers
  onSubmit, onCancelClick,
  // fields
  principalAmount, onPrincipalAmountChange, principalAmountError, setPrincipalAmountError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Adjust Principal'
    buttonLabel='Pay'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    {
      status === 'unpaid' &&
      <>
        <InputTextSF type='text' name='principalAmount' required={true} label='Principal amount'
          value={principalAmount} onChange={onPrincipalAmountChange}
          error={principalAmountError} setError={setPrincipalAmountError}
          autoFocus={true}
        />
      </>
    }

  </ModalFormUI>

export default RepaymentPrincipalModalUI

